import { format, isValid, parseISO } from 'date-fns'

export const MASK_TEMPLATE = 'MM/DD/YYYY'
export const DATE_FORMAT = 'MM/dd/yyyy'
export const DIGIT_POSITIONS = [0, 1, 3, 4, 6, 7, 8, 9]

export function digitsToMasked(digits: string): string {
  let result = ''
  let di = 0
  for (let i = 0; i < MASK_TEMPLATE.length; i++) {
    if (MASK_TEMPLATE[i] === '/') {
      result += '/'
    } else if (di < digits.length) {
      result += digits[di++]
    } else {
      result += MASK_TEMPLATE[i]
    }
  }
  return result
}

export function maskedCursorPosition(digitCount: number): number {
  if (digitCount >= 8) return 10
  return DIGIT_POSITIONS[digitCount]
}

export function dateToDigits(d: Date): string {
  return format(d, DATE_FORMAT).replace(/\//g, '')
}

export function parseStoredDate(value: string): Date | undefined {
  if (!value) return undefined
  const d = parseISO(value)
  return isValid(d) ? d : undefined
}

export function dateToStoredString(d: Date): string {
  return format(d, 'yyyy-MM-dd')
}

export function dateToDisplay(d: Date): string {
  return format(d, 'dd MMM yyyy')
}
